import { Injectable } from '@angular/core';
import { CommandesService, InlineResponse200 } from '../../../../openapi/build';
import { Observable, of, shareReplay, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StatutCommandeService {
  private statuts: InlineResponse200[] | null = null;
  private statuts$: Observable<InlineResponse200[]> | null = null;

  constructor(private readonly commandesService: CommandesService) {}

  /**
   * Récupère la liste des statuts de commande.
   * Utilise le cache si disponible.
   */
  public getStatuts(): Observable<InlineResponse200[]> {
    if (this.statuts) {
      return of(this.statuts);
    }
    if (!this.statuts$) {
      this.statuts$ = this.commandesService.getApiCommandesStatutsList().pipe(
        tap((statuts) => {
          this.statuts = statuts as InlineResponse200[];
          this.statuts$ = null; // Réinitialise l'observable une fois terminé pour permettre un futur rechargement si besoin
        }),
        shareReplay(1)
      );
    }
    return this.statuts$;
  }

  /**
   * Retourne le libellé d'un statut à partir de son code.
   * Note: Comme les statuts sont chargés de manière asynchrone,
   * cette méthode peut retourner le code si les statuts ne sont pas encore chargés.
   */
  public getLibelle(code: string | null | undefined): string {
    if (!code) {
      return '';
    }
    if (!this.statuts) {
      return code;
    }
    const option = this.statuts.find((o: InlineResponse200) => o.code === code);
    return option?.libelle ?? code;
  }
}
